import React, { useRef, useState, useId } from "react";
import './MyAccount.scss';
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MyAccountDashboard from './MyAccountDashboard/MyAccountDashboard'
import MyAccountProjects from './MyAccountProjects/MyAccountProjects'
import MyAccountReviews from './MyAccountReviews/MyAccountReviews'
import MyAccountManage from './MyAccountManage/MyAccountManage'

export default function MyAccount({ setUpdateApp, ProjectList, ServicesData, UserSession, showsetNotification, showsetNotificationType }) {
    // Helpers
    const [Render, setRender] = useState(false);
    const [ShowSearch, setShowSearch] = useState(false);
    const [ScrollToPage, setScrollToPage] = useState(false);
    const [ScrollToPageBottom, setScrollToPageBottom] = useState(false);
    const [SearchQuery, setSearchQuery] = useState("");
    const [ServicesDataNew, setServicesDataNew] = useState([]);
    const [ServicesDataNewSubCategory, setServicesDataNewSubCategory] = useState([]);

    const navigate = useNavigate();
    const location = useLocation()
    const url = new URL(window.location.href);
    // intervalFun()
    const containerRef = useRef(null);
    const scrollRightHowItWork = (pages, leftOrReight, pixels) => {
        const container = containerRef.current;
        const numvver = pixels
        if (container && leftOrReight == true) {
            const scrollAmount = (container.clientWidth * pages);
            container.scrollLeft = scrollAmount + parseInt(numvver);
        } else if (container && leftOrReight == false) {
            const scrollAmount = (container.clientWidth * pages - container.clientWidth - container.clientWidth);
            container.scrollLeft = scrollAmount + parseInt(numvver);
        }
    };


    var timesRun = 0;
    // Loading Function
    const intervalFun = (seconds) => {
        var interval = setInterval(function () {
            console.log("yes adfter 3 sec");
            clearInterval(interval);
        }, 1000);
    }

    useEffect(() => {
        // Convert Main Servcies Data to one data include All (SubCategory)
        let arrray = []
        for (let index = 0; index < ServicesData.length; index++) {
            for (let index2 = 0; index2 < ServicesData[index].sub_services.length; index2++) {
                // console.log(arrray);
                arrray.push(ServicesData[index].sub_services[index2])
            }
        }
        setServicesDataNew(arrray.sort())
        setServicesDataNewSubCategory(arrray.sort());

        if (url.pathname.split('/')[2] == "projects") {
            scrollRightHowItWork(1, true, "+0px")
        } else if (url.pathname.split('/')[2] == "reviews") {
            scrollRightHowItWork(2, true, "+0px")
        } else if (url.pathname.split('/')[2] == "manage") {
            scrollRightHowItWork(3, true, "+0px")
        } else if (url.pathname.split('/')[2] == "categories") {
            scrollRightHowItWork(4, true, "+0px")
        }
    }, []);

    return (
        <div className="MyAccount">
            <div className={
                ScrollToPage ? "MyAccountHeader MyAccountHeaderAnime" :
                    ScrollToPageBottom ? "MyAccountHeader MyAccountHeaderAnimeBottom" :
                        "MyAccountHeader"
            }>
                <div className="MyAccountHeaderSearchCloseSSearch" onMouseOver={() => {
                    setShowSearch(false)
                    setRender(a => !a)
                }}></div>
                <h1 onMouseOver={() => {
                    setShowSearch(false)
                    setRender(a => !a)
                }}>Welcome back{UserSession && UserSession.FirstName ? ", " + UserSession.FirstName : ""}</h1>
                <div className="MyAccountHeaderSearch">
                    <div className="HomePageTopBannerText" onMouseDown={() => {
                        setShowSearch(true)
                        setRender(a => !a)
                    }} >
                        <div className="HomePageTopBannerTextInputMain" >
                            <div on className="HomePageTopBannerTextInput">
                                <div className="HomePageTopBannerTextInputImg">
                                    {ShowSearch && SearchQuery.length ?
                                        <img className="HomePageTopBannerTextInputImg_Close" src={require(`../../Images/closeMenu.png`)} onClick={() => {
                                            setRender(a => !a)
                                            setSearchQuery("")
                                        }} />
                                        :
                                        <img src={require(`../../Images/search1.png`)} />
                                    }
                                </div>
                                <div className="HomePageTopBannerTextInputInputs">
                                    <input

                                        className="InputQuestion"
                                        placeholder="Tell us what you need help with"
                                        value={SearchQuery}
                                        onClick={() => {
                                            setShowSearch(true)
                                            // window.scrollTo(0, 0)
                                        }}
                                        onChange={(a) => {
                                            setShowSearch(true)
                                            setRender(a => !a)
                                            let newnew = ServicesDataNewSubCategory.filter((a2 => a2.toLowerCase().includes(a.target.value.toLocaleLowerCase())))
                                            setRender(a => !a)
                                            setSearchQuery(a.target.value.toLocaleLowerCase())
                                            setServicesDataNew(newnew)
                                        }} />
                                </div>
                            </div>
                        </div>
                        <a className="HomePageTopBannerTextRequesst" href={`/start-project`} >Find Pro</a>
                    </div>
                    {ShowSearch ?
                        <div className="HomePageTopBannerTextInputSearchResults" onBlur={() => {
                            setShowSearch(false)
                            setRender(a => !a)
                        }} >
                            <div className="HomePageTopBannerTextInputSearchResultsList">
                                {

                                    ServicesDataNew.length > 0 ?
                                        ServicesDataNew.map((A, Index) =>
                                            <a href={`/request-service?service=${A}`} className="HomePageTopBannerTextInputSearchResultsListBox">
                                                <img className="HomePageTopBannerTextInputSearchResultsListBoxImg" src={require(`../../Images/search.png`)} alt="Chimney Cleaning" />
                                                <a href={`/request-service?service=${A}`}>{A}</a>
                                            </a>
                                        )
                                        :
                                        <div className="HomePageTopBannerTextInputSearchResultsListBox">
                                            <img className="HomePageTopBannerTextInputSearchResultsListBoxImg" src={require(`../../Images/search.png`)} />
                                            <a >No results</a>
                                        </div>
                                }
                            </div>

                        </div>
                        : null}
                </div>
                <p>Or search for ssomething else....</p>
            </div>
            <div className="MyAccountMain" onMouseOver={() => {
                setShowSearch(false)
                setRender(a => !a)
            }}>
                <div className="MyAccountMenu">
                    <div className="MyAccountMenuBox" onClick={() => {
                        navigate('/account/dashboard')

                        if (window.innerWidth < 800 & url.pathname.split('/')[2] != "dashboard" && ScrollToPage) {
                            setScrollToPage(false)
                            setScrollToPageBottom(true)
                            setRender(a => !a)
                            console.log("yes");
                        } else if (window.innerWidth < 800) {
                            setScrollToPage(true)
                            setScrollToPageBottom(false)
                            setRender(a => !a)
                            console.log("no");
                        }
                        var interval = setInterval(function () {
                            scrollRightHowItWork(0, true, "+0px")
                            clearInterval(interval);
                        }, 200);

                    }} style={url.pathname.split('/')[2] == "dashboard" ? { "backgroundColor": "#0a65fc" } : null}>
                        <img src={require(`../../Images/3d-house.png`)} />
                        <h2 style={url.pathname.split('/')[2] == "dashboard" ? { "color": "white" } : null}>{window.innerWidth > 800 ? "Dashboard" : url.pathname.split('/')[2] == "dashboard" && window.innerWidth < 800 ? "Dashboard" : ""}</h2>
                        <img src={require(`../../Images/ArrowDown.png`)} style={url.pathname.split('/')[2] == "dashboard" ? { "filter": "invert(1)" } : null} />
                    </div>

                    <div className="MyAccountMenuBox" onClick={() => {
                        // window.scrollTo(0, -300)
                        navigate('/account/projects')
                        
                        if (window.innerWidth < 800) {
                            setScrollToPage(true)
                            setRender(a => !a)
                        }
                        var interval = setInterval(function () {
                            scrollRightHowItWork(1, true, "+0px")
                            clearInterval(interval);
                        }, 200);
                    }} style={url.pathname.split('/')[2] == "projects" ? { "backgroundColor": "#0a65fc" } : null}>
                        <img src={require(`../../Images/document.png`)} />
                        <h2 style={url.pathname.split('/')[2] == "projects" ? { "color": "white" } : null}>{window.innerWidth > 800 ? "Projects" : url.pathname.split('/')[2] == "projects" && window.innerWidth < 800 ? "Projects" : ""}</h2>
                        <img src={require(`../../Images/ArrowDown.png`)} style={url.pathname.split('/')[2] == "projects" ? { "filter": "invert(1)" } : null} />
                    </div>

                    <div className="MyAccountMenuBox" onClick={() => {
                        navigate('/account/reviews')
                        if (window.innerWidth < 800) {
                            setScrollToPage(true)
                            setRender(a => !a)
                        }
                        var interval = setInterval(function () {
                            scrollRightHowItWork(2, true, "+0px")
                            clearInterval(interval);
                        }, 200);

                    }} style={url.pathname.split('/')[2] == "reviews" ? { "backgroundColor": "#0a65fc" } : null}>
                        <img src={require(`../../Images/verify.png`)} />
                        <h2 style={url.pathname.split('/')[2] == "reviews" ? { "color": "white" } : null}>{window.innerWidth > 800 ? "My Reviews" : url.pathname.split('/')[2] == "reviews" && window.innerWidth < 800 ? "My Reviews" : ""}</h2>
                        <img src={require(`../../Images/ArrowDown.png`)} style={url.pathname.split('/')[2] == "reviews" ? { "filter": "invert(1)" } : null} />
                    </div>

                    <div className="MyAccountMenuBox" onClick={() => {
                        navigate('/account/manage')
                        if (window.innerWidth < 800) {
                            setScrollToPage(true)
                            setRender(a => !a)
                        }
                        var interval = setInterval(function () {
                            scrollRightHowItWork(3, true, "+0px")
                            clearInterval(interval);
                        }, 200);

                    }} style={url.pathname.split('/')[2] == "manage" ? { "backgroundColor": "#0a65fc" } : null}>
                        <img src={require(`../../Images/information.png`)} />
                        <h2 style={url.pathname.split('/')[2] == "manage" ? { "color": "white" } : null}>{window.innerWidth > 800 ? "Account Info" : url.pathname.split('/')[2] == "manage" && window.innerWidth < 800 ? "Account Info" : ""}</h2>
                        <img src={require(`../../Images/ArrowDown.png`)} style={url.pathname.split('/')[2] == "manage" ? { "filter": "invert(1)" } : null} />
                    </div>

                    <div className="MyAccountMenuBox" onClick={() => {
                        navigate('/account/categories')
                        if (window.innerWidth < 800) {
                            setScrollToPage(true)
                            setRender(a => !a)
                        }
                        var interval = setInterval(function () {
                            scrollRightHowItWork(4, true, "+0px")
                            clearInterval(interval);
                        }, 200);
                    }} style={url.pathname.split('/')[2] == "categories" ? { "backgroundColor": "#0a65fc" } : null}>
                        <img src={require(`../../Images/house.png`)} />
                        <h2 style={url.pathname.split('/')[2] == "categories" ? { "color": "white" } : null}>{window.innerWidth > 800 ? "My Categories" : url.pathname.split('/')[2] == "categories" && window.innerWidth < 800 ? "Categories" : ""}</h2>
                        <img src={require(`../../Images/ArrowDown.png`)} style={url.pathname.split('/')[2] == "categories" ? { "filter": "invert(1)" } : null} />
                    </div>


                </div>
                <div className="MyAccountPage">
                    <div className="MyAccountPageShape">
                        <div className="MyAccountPageShapeInSide"></div>
                    </div>
                    <div className="MyAccountPageNav">
                        <h1>HandyBy Account &nbsp; &gt;</h1>
                        <h1>{String(url.pathname.split('/')[2]).charAt(0).toUpperCase() + String(url.pathname.split('/')[2]).slice(1)}</h1>
                    </div>
                    <div className="MyAccountPageCorrct" ref={containerRef}>

                        <MyAccountDashboard />
                        <MyAccountProjects ProjectList={ProjectList} />
                        <MyAccountReviews />
                        <MyAccountManage />


                        {/* {url.pathname.split('/')[2] == 'dashboard' ?
                            <MyAccountDashboard /> :
                            url.pathname.split('/')[2] == 'projects' ?
                                <MyAccountProjects ProjectList={ProjectList} /> :
                                url.pathname.split('/')[2] == 'reviews' ?
                                    <MyAccountReviews /> :
                                    url.pathname.split('/')[2] == 'manage' ?
                                        <MyAccountManage /> :
                                        null
                        } */}
                    </div>
                </div>
            </div>
        </div >
    )
}

